import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-modal-shell',
  imports: [],
  templateUrl: './modal-shell.component.html',
  styleUrl: './modal-shell.component.scss'
})
export class ModalShellComponent {
  @Input() title = '';
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() closeDisabled = false;
  @Output() closed = new EventEmitter<void>();

  close(): void {
    if (this.closeDisabled) {
      return;
    }
    this.closed.emit();
  }
}
